import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const FAQSection = styled.section`
  padding: 6rem 8rem;
  background-color: white;
  
  @media (max-width: 1024px) {
    padding: 4rem 2rem;
  }
`;

const FAQContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const FAQTitle = styled.h2`
  text-align: center;
  margin-bottom: 4rem;
  font-size: 2.5rem;
  color: #3182CE;
`;

const FAQItem = styled.div`
  margin-bottom: 1.5rem;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Question = styled.button`
  width: 100%;
  text-align: left;
  padding: 1.5rem;
  background: white;
  border: none;
  font-size: 1.2rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  span {
    font-size: 1.5rem;
    color: #0052CC;
    transition: transform 0.3s ease;
  }
`;

const Answer = styled.div<{ isOpen: boolean }>`
  padding: ${props => props.isOpen ? '0 1.5rem 1.5rem 1.5rem' : '0 1.5rem'};
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  color: #666;
  line-height: 1.6;
  font-size: 1.1rem;
`;

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useLanguage();
  
  // 获取FAQ项目，确保设置returnObjects选项为true
  const faqItems = t('faq.items', { returnObjects: true }) as Array<{ question: string; answer: string }>;

  return (
    <FAQSection id="faq">
      <FAQContainer>
        <FAQTitle>{t('faq.title')}</FAQTitle>
        {faqItems.map((faq: any, index: number) => (
          <FAQItem key={index}>
            <Question onClick={() => setOpenIndex(openIndex === index ? null : index)}>
              {faq.question}
              <span style={{ transform: openIndex === index ? 'rotate(45deg)' : 'none' }}>+</span>
            </Question>
            <Answer isOpen={openIndex === index}>
              {faq.answer}
            </Answer>
          </FAQItem>
        ))}
      </FAQContainer>
    </FAQSection>
  );
};

export default FAQ; 